module.exports = __webpack_public_path__ + "media/application/images/icons/white-bullet-b1d3f0bf37d040b7210a7947c50eeb42.svg";